import { render, staticRenderFns } from "./ServiceEdit.vue?vue&type=template&id=2016a5c4&scoped=true"
import script from "./ServiceEdit.vue?vue&type=script&lang=js"
export * from "./ServiceEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceEdit.vue?vue&type=style&index=0&id=2016a5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016a5c4",
  null
  
)

export default component.exports